import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { EffectRow } from "./EffectRow";

export const RuleEngineEffectEndStepFragment = graphql(`
  fragment RuleEngineEffectEndStepFields on RuleEngineEffectEndStepPayload {
    __typename
    effectKind
    stepId
    beforeStepStatus
    afterStepStatus
    applied
    skipReason
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineEffectEndStepFragment>;
}

export function RuleEngineEffectEndStepPayload({ data }: Props) {
  const p = readFragment(RuleEngineEffectEndStepFragment, data);
  return (
    <EffectRow
      applied={p.applied}
      appliedColor="violet"
      appliedLabel="END_STEP"
      skipReason={p.skipReason}
    >
      step {p.stepId.slice(0, 8)}: {p.beforeStepStatus} → {p.afterStepStatus}
    </EffectRow>
  );
}
